<button class="dialog-close" (click)="close()" type="button" aria-label="Close">
  <i class="pi pi-times"></i>
</button>

<div>
  @if (config.data?.message) {
    <p>{{ config.data.message }}</p>
  }

  @if (!isRegisterMode) {
    <app-login-form (success)="onSuccess()" (switchToRegister)="switchMode()"></app-login-form>
  }
  @if (isRegisterMode) {
    <app-register-form (success)="onSuccess()"></app-register-form>
  }
  @if (isRegisterMode) {
    <a (click)="switchMode()" class="text-center cursor-pointer mt-3 block">
      {{ 'auth.have_account' | translate }}
    </a>
  }
</div>
